// Metadados visuais das seções (cor/ícone/rótulo). Nunca depender só da cor:
// sempre acompanha ícone + rótulo textual (acessibilidade, spec 9).
import {
  PlayCircle, AlignLeft, ChevronsUp, Star, ChevronsDown, GitBranch, Music2,
  Guitar, Radio, Pause, Megaphone, Mic2, RefreshCw, Repeat2, Square, LogOut,
  Drum, Hand, MessageCircle, CornerUpLeft, ListMusic, ArrowRightLeft,
} from "lucide-react";

// tone = token semântico do design system (primary/accent/info/warning/success/muted)
export const SECTION_META = {
  INTRO: { label: "Intro", short: "INTRO", icon: PlayCircle, tone: "info" },
  VERSO: { label: "Verso", short: "V", icon: AlignLeft, tone: "muted" },
  PRE_REFRAO: { label: "Pré-refrão", short: "PRÉ", icon: ChevronsUp, tone: "warning" },
  REFRAO: { label: "Refrão", short: "REFRÃO", icon: Star, tone: "primary", strong: true },
  POS_REFRAO: { label: "Pós-refrão", short: "PÓS", icon: ChevronsDown, tone: "warning" },
  PONTE: { label: "Ponte", short: "PONTE", icon: GitBranch, tone: "accent" },
  INTERLUDIO: { label: "Interlúdio", short: "INTER", icon: Music2, tone: "info" },
  SOLO: { label: "Solo", short: "SOLO", icon: Guitar, tone: "accent" },
  INSTRUMENTAL: { label: "Instrumental", short: "INST", icon: Radio, tone: "info" },
  BREAK: { label: "Break", short: "BREAK", icon: Pause, tone: "warning" },
  CONVENCAO: { label: "Convenção", short: "CONV", icon: Megaphone, tone: "warning" },
  RAP: { label: "Rap", short: "RAP", icon: Mic2, tone: "muted" },
  MODULACAO: { label: "Modulação", short: "MOD", icon: RefreshCw, tone: "accent" },
  REPETICAO: { label: "Repetição", short: "REP", icon: Repeat2, tone: "muted" },
  FINAL: { label: "Final", short: "FINAL", icon: Square, tone: "success" },
  OUTRO: { label: "Outro", short: "OUTRO", icon: LogOut, tone: "success" },
  PARTIDO_ALTO: { label: "Partido Alto", short: "P.ALTO", icon: Drum, tone: "accent" },
  PARADINHA: { label: "Paradinha", short: "PARA", icon: Hand, tone: "warning" },
  CHAMADA: { label: "Chamada", short: "CHAM", icon: Megaphone, tone: "info" },
  RESPOSTA: { label: "Resposta", short: "RESP", icon: MessageCircle, tone: "info" },
  VOLTA: { label: "Volta", short: "VOLTA", icon: CornerUpLeft, tone: "muted" },
  MEDLEY: { label: "Medley", short: "MEDLEY", icon: ListMusic, tone: "accent" },
  TRANSICAO: { label: "Transição", short: "TRANS", icon: ArrowRightLeft, tone: "muted" },
  MUSICA: { label: "Trecho", short: "TRECHO", icon: Music2, tone: "muted" },
};

export const SECTION_ORDER = Object.keys(SECTION_META);

export function metaFor(type) {
  return SECTION_META[type] || SECTION_META.MUSICA;
}

export function toneStyle(tone, opacityBg = 0.08) {
  return {
    borderColor: `hsl(var(--${tone}))`,
    color: `hsl(var(--${tone}))`,
    background: `hsl(var(--${tone}) / ${opacityBg})`,
  };
}
